import React from "react";
import { Modal, Box, CircularProgress, Typography } from "@mui/material";

function LoadingModal({ open, message = "Processing...", message2 = "", message3 = "" }) {
    return (
        <Modal
            open={open}
            aria-labelledby="loading-modal"
            aria-describedby="loading-spinner"
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
            <Box
                sx={{
                    bgcolor: "background.paper",
                    p: 4,
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <CircularProgress />
                <Typography>{message}</Typography>
                <Typography>{message2}</Typography>
                <Typography>{message3}</Typography>
                
            </Box>
        </Modal>
    );
}

export default LoadingModal;
